import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DatePickerContainer, HoursInput } from "./style";

const EnhancedDateRangePicker = ({
  hours,
  dateRange,
  setDateRange,
  hourRangeTo,
  setHourRangeTo,
  setHourRangeFrom,
  hourRangeFrom,
}) => {
  return (
    <DatePickerContainer>
      <label>
        {hours ? (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99996 1.66667C14.6023 1.66667 18.3333 5.39763 18.3333 10C18.3333 14.6024 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6024 1.66663 10C1.66663 5.39763 5.39759 1.66667 9.99996 1.66667ZM9.99996 3.33334C6.31806 3.33334 3.33329 6.31811 3.33329 10C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31811 13.6819 3.33334 9.99996 3.33334ZM9.99996 5.00001C10.4273 5.00001 10.7795 5.32171 10.8277 5.73615L10.8333 5.83334V9.65483L12.2559 11.0774C12.5813 11.4029 12.5813 11.9305 12.2559 12.2559C11.9555 12.5563 11.4828 12.5794 11.1559 12.3253L11.0774 12.2559L9.4107 10.5893C9.28047 10.459 9.19779 10.2901 9.17385 10.1095L9.16663 10V5.83334C9.16663 5.3731 9.53972 5.00001 9.99996 5.00001Z"
                fill="#EDEDED"
              />
            </svg>
            <HoursInput
              placeholder="From"
              type="number"
              value={hourRangeFrom || ""}
              onChange={(e) => setHourRangeFrom(e.target.value)}
            />
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.1667 1.6665C14.627 1.6665 15.0001 2.0396 15.0001 2.49984V3.33317H15.8334C17.2141 3.33317 18.3334 4.45246 18.3334 5.83317V15.8332C18.3334 17.2139 17.2141 18.3332 15.8334 18.3332H4.16675C2.78604 18.3332 1.66675 17.2139 1.66675 15.8332V5.83317C1.66675 4.45246 2.78604 3.33317 4.16675 3.33317H5.00008V2.49984C5.00008 2.0396 5.37318 1.6665 5.83342 1.6665C6.29365 1.6665 6.66675 2.0396 6.66675 2.49984V3.33317H13.3334V2.49984C13.3334 2.0396 13.7065 1.6665 14.1667 1.6665ZM3.33341 9.99984V15.8332C3.33341 16.2934 3.70651 16.6665 4.16675 16.6665H15.8334C16.2937 16.6665 16.6667 16.2934 16.6667 15.8332V9.99984H3.33341ZM3.33341 8.33317H16.6667V5.83317C16.6667 5.37293 16.2937 4.99984 15.8334 4.99984H15.0001V5.83317C15.0001 6.29341 14.627 6.6665 14.1667 6.6665C13.7065 6.6665 13.3334 6.29341 13.3334 5.83317V4.99984H6.66675V5.83317C6.66675 6.29341 6.29365 6.6665 5.83341 6.6665C5.37318 6.6665 5.00008 6.29341 5.00008 5.83317V4.99984H4.16675C3.70651 4.99984 3.33341 5.37293 3.33341 5.83317V8.33317Z"
                fill="#EDEDED"
              />
            </svg>
            <DatePicker
              selected={dateRange.from}
              onChange={(date) =>
                setDateRange((prev) => ({ ...prev, from: date }))
              }
              placeholderText="From"
              selectsStart
              startDate={dateRange.from}
              endDate={dateRange.to}
            />
          </>
        )}
      </label>
      <label>
        {hours ? (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99996 1.66667C14.6023 1.66667 18.3333 5.39763 18.3333 10C18.3333 14.6024 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6024 1.66663 10C1.66663 5.39763 5.39759 1.66667 9.99996 1.66667ZM9.99996 3.33334C6.31806 3.33334 3.33329 6.31811 3.33329 10C3.33329 13.6819 6.31806 16.6667 9.99996 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31811 13.6819 3.33334 9.99996 3.33334ZM9.99996 5.00001C10.4273 5.00001 10.7795 5.32171 10.8277 5.73615L10.8333 5.83334V9.65483L12.2559 11.0774C12.5813 11.4029 12.5813 11.9305 12.2559 12.2559C11.9555 12.5563 11.4828 12.5794 11.1559 12.3253L11.0774 12.2559L9.4107 10.5893C9.28047 10.459 9.19779 10.2901 9.17385 10.1095L9.16663 10V5.83334C9.16663 5.3731 9.53972 5.00001 9.99996 5.00001Z"
                fill="#EDEDED"
              />
            </svg>
            <HoursInput
              placeholder="To"
              value={hourRangeTo || ""}
              type="number"
              onChange={(e) => setHourRangeTo(e.target.value)}
            />
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.1667 1.6665C14.627 1.6665 15.0001 2.0396 15.0001 2.49984V3.33317H15.8334C17.2141 3.33317 18.3334 4.45246 18.3334 5.83317V15.8332C18.3334 17.2139 17.2141 18.3332 15.8334 18.3332H4.16675C2.78604 18.3332 1.66675 17.2139 1.66675 15.8332V5.83317C1.66675 4.45246 2.78604 3.33317 4.16675 3.33317H5.00008V2.49984C5.00008 2.0396 5.37318 1.6665 5.83342 1.6665C6.29365 1.6665 6.66675 2.0396 6.66675 2.49984V3.33317H13.3334V2.49984C13.3334 2.0396 13.7065 1.6665 14.1667 1.6665ZM3.33341 9.99984V15.8332C3.33341 16.2934 3.70651 16.6665 4.16675 16.6665H15.8334C16.2937 16.6665 16.6667 16.2934 16.6667 15.8332V9.99984H3.33341ZM3.33341 8.33317H16.6667V5.83317C16.6667 5.37293 16.2937 4.99984 15.8334 4.99984H15.0001V5.83317C15.0001 6.29341 14.627 6.6665 14.1667 6.6665C13.7065 6.6665 13.3334 6.29341 13.3334 5.83317V4.99984H6.66675V5.83317C6.66675 6.29341 6.29365 6.6665 5.83341 6.6665C5.37318 6.6665 5.00008 6.29341 5.00008 5.83317V4.99984H4.16675C3.70651 4.99984 3.33341 5.37293 3.33341 5.83317V8.33317Z"
                fill="#EDEDED"
              />
            </svg>
            <DatePicker
              selected={dateRange.to}
              onChange={(date) =>
                setDateRange((prev) => ({ ...prev, to: date }))
              }
              selectsEnd
              placeholderText="To"
              startDate={dateRange.from}
              endDate={dateRange.to}
              minDate={dateRange.from}
            />
          </>
        )}
      </label>
    </DatePickerContainer>
  );
};

export default EnhancedDateRangePicker;
